import {iframeReady} from "./youtubeApiInit";

const randomVideo = (videoContainer) => {
  const $videoContainer = videoContainer,
    $videoFiles = $videoContainer.find('.video, .video-iframe'),
    videoFilesTable = [...$videoFiles];

  let currentVideoIndex = null,
    currentVideoYoutube;

  function randomNumber(from, to) {
    return Math.floor((Math.random() * to) + from);
  }

  function playVideo() {
    function random() {
      let number = randomNumber(0, videoFilesTable.length);

      if (currentVideoIndex !== null && videoFilesTable.length > 1) {
        if (number === currentVideoIndex) {
          return random();
        } else {
          return number;
        }
      } else {
        return number;
      }
    }

    let index = random(),
      video = videoFilesTable[index];

    currentVideoIndex = index;

    $(video).parent().addClass('playing');

    if ($(video).hasClass('video')) {
      $(video).parent().addClass('playing');

      video.playbackRate = $(video).data('playback-rate') || 1;
      video.play();
    } else {
      iframeReady(function(e) {
        let playbackRate = $(video).data('playback-rate');

        currentVideoYoutube = e;

        $(video).parent().parent().addClass('playing');

        e.setPlaybackRate(playbackRate);
        e.mute();
        e.playVideo();
      }, video.id);      
    }    
  }  

  function onEnd(videoFilesTable) {
    videoFilesTable.forEach(function(video){
      if ($(video).hasClass('video')) {
        video.onended = function () {
          $(video).parent().removeClass('playing');
  
          playVideo();
        };
      } else {
        youTubePlayers.forEach(function(item, index) {
          if(item.a.id === video.id) {
            item.addEventListener('onStateChange', function(e) {      
              if(e.data === 0 && currentVideoIndex + 1 === index) {
                $(video).parent().parent().removeClass('playing');
  
                playVideo();                
              }
            }, false);
          }
        }); 
      }
    });    
  }

  function init() {
    $videoContainer.addClass('initiated');
    
    playVideo();
    onEnd(videoFilesTable);
  }

  init();
};

export default randomVideo;


// WEBPACK FOOTER //
// ./src/js/components/randomVideo.js